import axios from 'axios';
import { useEffect } from 'react'
import "./Intro.css"
import { ReactSVG } from 'react-svg';
import { useRef} from 'react';
import rect1 from "../assets/rectangle-1.svg";
import rect1Back from "../assets/rectangle-1-back.svg";
import rect2 from "../assets/rectangle-2.svg";
import rect2Back from "../assets/rectangle-2-back.svg";
import rect3 from "../assets/rectangle-3.svg";
import rect3Back from "../assets/rectangle-3-back.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner} from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import back from '../assets/back.png';
import front from '../assets/front.png';
import middle from '../assets/middle.png';
import { useTranslation } from 'react-i18next';

const Intro = () => {
  const { t } = useTranslation();
  const [icon,setIcon]= useState(faCheck);
  const check: any = useRef(null);
  const iconRef: any = useRef(null);
  const frontRef: any = useRef(null);
  const middleRef: any = useRef(null);
  const backRef: any = useRef(null);
  const introForm: any = useRef(null);
  const blobRef: any = useRef(null);


  const checkAnimation = () => {
    // e.preventDefault();
    check.current.animate(
      {width: '100%'}, { duration: 100, fill: "forwards", easing: "ease"}
      );
    setTimeout(() => {
      setIcon(faSpinner);
      iconRef.current.animate([{
        transform: 'rotate(0)'
      }, {transform: 'rotate(270deg)'} ], { duration: 1000});
    }, 80);

    setTimeout(() => {
      check.current.animate(
      {width: '22%'}, { duration: 150, fill: "forwards", easing: "ease"}
      );
      setIcon(faCheck);
    }, 1080);
    return;
  }

  const parallax = (e: any) => {
    let value = window.scrollY;
    // console.log(frontRef.current.parentElement.offsetHeight);
    let half = frontRef.current.parentElement.offsetHeight * 0.5;

    frontRef.current.style.top = half + value * 0.2 + 'px';
    middleRef.current.style.top = half + value * 0.15 + 'px';
    backRef.current.style.top = half + value * 0.1 + 'px'; 

    introForm.current.style.top = value * 0.2 + 'px';
    // frontRef.current.style.opacity = Math.max(window.innerHeight/2 - formVal, 0)+ '%';
    // middleRef.current.style.opacity = Math.max(window.innerHeight/2 - formVal, 0)+ '%';
    // backRef.current.style.opacity = Math.max(window.innerHeight/2 - formVal, 0)+ '%';

    // introForm.current.style.opacity = Math.max(window.innerHeight/1.5 - formVal, 0)+ '%';
    // if ( formVal >= window.innerHeight/1.5){
    //   introForm.current.style.top = window.innerHeight/1.5 + (formVal - window.innerHeight/1.5) *0.3 + 'px';
    // } else {
    //   introForm.current.style.top = formVal + 'px';
    // }

    console.log('scrolling');
  }
  const blobMove = (e: any) => {
    const { clientX, clientY } = e;
    blobRef.current.animate({
      left: `${clientX}px`,
      top: `${clientY}px`
    }, { duration: 3000, fill: "forwards" });
  }
  useEffect(() => {
      
    window.addEventListener('scroll', parallax);
    window.addEventListener('pointermove', blobMove);
    return () => {
      window.removeEventListener('scroll', parallax);
    }
}, []);

// Form post handlers
const [email, setEmail] = useState<string>("");
const changeHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
  setEmail(e.target.value);
}
const submitHandler = async (e:React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  checkAnimation();
  try {
    const response = await axios
      .post("/api/v1/users/emails/add", {email: email});
    console.log(response);
  } catch(error:any) {
    console.log(error.response.data);
  }
}

  return (
    <div className="intro">
        {/* <div className="intro__wrapper"> */}
          <div ref={blobRef} id="blob"></div>
          <div id="blur"></div>
        {/* </div> */}
      <div className="intro__content">
        <div className="intro__content__space-between">
          <div ref={introForm} className="intro__content__flex">
            <ReactSVG src={rect1} className="intro__content__flex__rect-1"></ReactSVG>
            <ReactSVG src={rect1Back} className="intro__content__flex__rect-1-back"></ReactSVG>
            <ReactSVG src={rect2} className="intro__content__flex__rect-2"></ReactSVG>
            <ReactSVG src={rect2Back} className="intro__content__flex__rect-2-back"></ReactSVG>
            <ReactSVG src={rect3} className="intro__content__flex__rect-3"></ReactSVG>
            <ReactSVG src={rect3Back} className="intro__content__flex__rect-3-back"></ReactSVG>
            <div className="intro__content__flex__large-heading">
              {t('introHead')}
            </div>
            <div className="intro__content__flex__small-text">
              {t('introSmall')}
            </div>
            <form action="post" className="intro__content__flex__form" onSubmit={submitHandler}>
              <input placeholder={`${t('inputEmail')}`} onChange={changeHandler}>
              </input>
              <button ref={check} type="submit" className="intro__content__flex__button"> <FontAwesomeIcon ref={iconRef} icon={icon} /></button>
            </form>
          </div>
          <div className="intro__splash__container">
            {/* <img src={splash} alt="splash" /> */}
            {/* <div className="intro__splash__container"> */}
            <img src={front} alt="" ref={frontRef} className="intro__splash" id="intro__splash__front" />
            <img src={middle} alt="" ref={middleRef} className="intro__splash" id="intro__splash__middle"/>
            <img src={back} alt="" ref={backRef} className="intro__splash" id="intro__splash__back" />
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Intro